// extracted by mini-css-extract-plugin
export default {"awardsContainer":"Awards_awardsContainer__VZGpn","mainContent":"Awards_mainContent__NsyTN","awardsMain":"Awards_awardsMain__tZliY"};